import { render, staticRenderFns, recyclableRender, components } from "./change-password.vue?vue&type=template&id=a42599ea&scoped=true&"
var renderjs
import script from "./change-password.vue?vue&type=script&lang=js&"
export * from "./change-password.vue?vue&type=script&lang=js&"
import style0 from "./change-password.vue?vue&type=style&index=0&id=a42599ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a42599ea",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "shop/pages/change-password/change-password.vue"
export default component.exports